import React, { Component } from 'react';

class AnswerOption extends Component {
  constructor(props, context) {
    super(props, context);
    this.updateValue = this.updateValue.bind(this);
  }

  updateValue(e) {
    this.props.onChange({ ...this.props.answerOption, value: e.target.value });
  }

  render() {
    const { answerOption, remove, promote, demote } = this.props;

    return (
      <div className="question-control-group">
        <label className="question-control-label">Option:</label>
        <div className="question-controls">
          <div className="input-append">
            <input
              data-spec-class="answer-option-input"
              type="text"
              value={answerOption.value}
              onChange={this.updateValue}
              className="form-control"
            />

            <button className="btn" type="button" onClick={promote}>
              <i className="icon-arrow-up" />
            </button>
            <button className="btn" type="button" onClick={demote}>
              <i className="icon-arrow-down" />
            </button>
            <button className="btn btn-danger" type="button" onClick={remove}>
              <i className="icon-remove icon-white" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AnswerOption;
